export default __webpack_public_path__ + "static/media/git.1dc6856e.svg";